// src/pages/ContactPage.tsx — Site officiel Vanessa : contact
import { Mail, Code2, Handshake, Flag } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageHeader, Section, Grid, FeatureCard } from '@/components/site/blocks';
import { CONTACT_EMAIL } from '@/config/site';

const mail = (subject: string) => `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;

export default function ContactPage() {
    return (
        <>
            <PageHeader eyebrow="Contact" title="Écrivez-nous." intro="Une question, une idée, un problème : nous lisons chaque message." />
            <Section>
                <Grid cols={3}>
                    <FeatureCard icon={Handshake} title="Partenariat">
                        Média, association, institution ? <a className="font-semibold text-ochre underline" href={mail('Partenariat Vanessa')}>Parlons-en</a>.
                    </FeatureCard>
                    <FeatureCard icon={Code2} title="API et développeurs">
                        Une question sur votre clé ou l’intégration ? <a className="font-semibold text-ochre underline" href={mail('API Vanessa')}>Écrivez-nous</a>, après un coup d’œil à la <Link className="font-semibold text-ochre underline" to="/documentation">documentation</Link>.
                    </FeatureCard>
                    <FeatureCard icon={Flag} title="Signaler un contenu">
                        Le plus rapide : le bouton « Signaler » dans l’application. Pour un cas grave, <a className="font-semibold text-ochre underline" href={mail('Signalement')}>écrivez-nous</a>.
                    </FeatureCard>
                </Grid>
                <div className="mt-8 flex items-center gap-3 rounded-2xl bg-brand-tint p-6">
                    <Mail className="h-6 w-6 shrink-0 text-ochre" aria-hidden="true" />
                    <p className="text-lg text-ink">
                        Adresse de contact : <a className="font-semibold text-ochre underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                    </p>
                </div>
            </Section>
        </>
    );
}
